import { Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'lms-select-dashboard',
  templateUrl: './select-dashboard.component.html',
  styleUrls: ['./select-dashboard.component.scss']
})
export class SelectDashboardComponent implements OnInit {
  @Input() public selectionList: any[] = [];
  @Input() public defaultFilter: any;
  @Output() public selectedFilter: EventEmitter<Object> = new EventEmitter<Object>();
  public selectedItem: Object;
  public toggleDropdown: boolean = false;
  constructor(public elementRef: ElementRef) {}

  public ngOnInit(): void {
    this.selectedItem = this.defaultFilter || this.selectionList[0];
  }

  public trackByList(index: number, item: any): number | string {
    return item ? item.key : null;
  }

  /**
   * Click when the item of the select is selected
   * @param item
   */
  public onClickItem(item: Object): void {
    this.selectedItem = item;
    this.selectedFilter.emit(item);
    this.toggleDropdown = false;
  }

  @HostListener('document:click', ['$event'])
  hideToggle(event) {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.toggleDropdown = false;
    }
  }
}
